import { post } from './fetcher';

const ADMIN_MEMBERSHIP_ENDPOINTS = {
  UPDATE_GRADE: '/api/admin/membership/update-grade',
  EXTEND_PERIOD: '/api/admin/membership/extend-period',
};

export const updateMembershipGrade = async (token, payload) => {
  return post(ADMIN_MEMBERSHIP_ENDPOINTS.UPDATE_GRADE, payload, token);
};

export const extendMembershipPeriod = async (token, payload) => {
  return post(ADMIN_MEMBERSHIP_ENDPOINTS.EXTEND_PERIOD, payload, token);
};
